import React, { useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { graphql } from "gatsby"
import { PrismicRichText } from "@prismicio/react"
import { idMaker } from "../utils/idMaker"

const QAItem = ({ index, item, isOpen, onToggle }) => {
  const panelId = `faq-panel-${index}`
  const buttonId = `faq-button-${index}`
  const anchorId = item.question ? idMaker(item.question) : panelId

  return (
    <li className={`faq-item ${isOpen ? "faq-item--open" : ""}`} id={anchorId}>
      {/* Accordion pattern: the toggle button lives inside a heading so each
          question is an H3 under the FAQ section's H2. */}
      <h3 className="faq-question-heading">
        <button
          id={buttonId}
          type="button"
          aria-expanded={isOpen}
          aria-controls={panelId}
          onClick={onToggle}
          className="faq-question"
        >
          <span>{item.question}</span>
          <span className="faq-icon" aria-hidden="true" />
        </button>
      </h3>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        className="faq-answer"
        hidden={!isOpen}
      >
        <PrismicRichText
          field={item.answer.richText}
          components={{
            paragraph: ({ children }) => (
              <p className="faq-answer-text">{children}</p>
            ),
          }}
        />
      </div>
    </li>
  )
}

export const FAQ = ({ slice }) => {
  const items = slice.items || []
  const mid = Math.ceil(items.length / 2)
  const left = items.slice(0, mid)
  const right = items.slice(mid)

  const [openSet, setOpenSet] = useState(() => new Set())
  const toggle = (idx) =>
    setOpenSet((prev) => {
      const next = new Set(prev)
      if (next.has(idx)) next.delete(idx)
      else next.add(idx)
      return next
    })

  return (
    <div className="faq" id={idMaker(slice.primary.title.text)}>
      <section className="faq-section">
        <Container>
          <Row>
            <Col className="col-lg-10 col-12 offset-lg-1 offset-0">
              <h2 className="faq-heading">{slice.primary.title.text}</h2>

              <Row className="g-lg-5">
                <Col xs={12} lg={6}>
                  <ul className="faq-list">
                    {left.map((item, i) => (
                      <QAItem
                        key={`faq-l-${i}`}
                        index={i}
                        item={item}
                        isOpen={openSet.has(i)}
                        onToggle={() => toggle(i)}
                      />
                    ))}
                  </ul>
                </Col>
                <Col xs={12} lg={6}>
                  <ul className="faq-list">
                    {right.map((item, i) => {
                      const realIndex = mid + i
                      return (
                        <QAItem
                          key={`faq-r-${realIndex}`}
                          index={realIndex}
                          item={item}
                          isOpen={openSet.has(realIndex)}
                          onToggle={() => toggle(realIndex)}
                        />
                      )
                    })}
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  )
}

export const query = graphql`
  fragment HomepageDataBodyFaq on PrismicHomepageDataBodyFaq {
    id
    slice_type
    primary {
      title {
        richText
        text
      }
    }
    items {
      question
      answer {
        richText
        text
      }
    }
  }

  fragment PageDataBodyFaq on PrismicPageDataBodyFaq {
    id
    slice_type
    primary {
      title {
        richText
        text
      }
    }
    items {
      question
      answer {
        richText
        text
      }
    }
  }
`
